import _ from 'lodash';

module.exports = {
    getFileType: function (str){
        let extension = str.substring(str.lastIndexOf(".") + 1);
        switch (extension){
          case "jpg":
          case "JPG":
          case "JPEG":
          case "jpeg":
          case "png":
          case "PNG":
          case "gif":
          case "GIF":
          return "Image";
          case "mp4":
          case "MP4":
          case "webm":
          case "WEBM":
          return "Video";
          default:
          return "Other";
        }
      },

    videoType: function(file_name){
        let videoExt = file_name.split('.').pop();
        switch (videoExt){
            case 'mov':
            return "video/mp4";
            case 'webm':
            return "video/webm";
            case "ogg":
            return "video/ogg";
            default:
            return null;
        }
    },
}




// WEBPACK FOOTER //
// ./src/utils/fileHelpers.js